export enum LocalStorageKey {
  ManuallyDisabled = "itpo-notif-disabled",
  Volume = "itpo-volume",
}
